<template>
  <div class="not-found-view">
    <div class="floating-card">
      <h1 class="card-text">
        Page Not Found
      </h1>
      <div class="success-wrapper">
        We searched all over in the shop.
        The page you are looking for appears to not exist.
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NotFound'
})
</script>

<style scoped lang="scss">

.not-found-view {
  @include sac-floating-card-view;
}

</style>
